<template>
    <div v-if="value" class="vx-card p-8 flex flex-col gap-4">
        <vs-input class="border-grey-light w-full" type="text" v-model="internalCommunity.name"
            :label="$t('admin.communities.name')" :danger="internalCommunity.name == ''"
            @input="$emit('input', internalCommunity)" />

        <vs-input class="border-grey-light w-full" type="text" v-model="internalCommunity.transactionals_sender_email"
            :label="$t('admin.communities.transactional_sender_email')"
            :danger="internalCommunity.transactionals_sender_email == ''" @input="$emit('input', internalCommunity)" />

        <vs-select class="w-full border-grey-light"
            :label="$t('admin.communities.transactional_mail_provider')"
            v-model="internalCommunity.transactional_mail_provider"
            @input="$emit('input', internalCommunity)">
            <vs-select-item v-for="provider in transactionalMailProviders" :key="provider" :value="provider"
                :text="provider" />
        </vs-select>

        <CreatableSelect
            :value="internalCommunity.id_conditions_ref"
            :multiple="false"
            :options="conditions.map(c => ({ key: c.reference, text: c.reference }))"
            :label="$t('admin.apps.main.id-ref')"
            create-route-name="admin-app-condition-create"
            :reload="reloadConditions"
            :resolve-created-key="payload => payload.reference"
            :created-to-option="payload => ({ key: payload.reference, text: payload.reference })"
            @reloaded="list => $emit('reloaded', list)"
            @input="val => { internalCommunity.id_conditions_ref = val; $emit('input', internalCommunity) }"
        />

        <vs-checkbox class="ml-0" v-model="internalCommunity.auto_validate_users"
            @change="$emit('input', internalCommunity)">
            {{ $t('admin.communities.auto_validate_users') }}
        </vs-checkbox>

        <div class="flex items-center ml-0 gap-4 mt-5">
            <vs-button :disabled="!isValid" class="rounded-lg xs:w-full sm:w-auto" @click="$emit('save')">
                {{ $t('resorts.touristic-objects.form.saveButton') }}
            </vs-button>
            <vs-button type="border" class="rounded-lg xs:w-full sm:w-auto text-primary" @click="$emit('cancel')">
                {{ $t('resorts.touristic-objects.form.cancelButton') }}
            </vs-button>
        </div>
    </div>
</template>

<script>
import LabelForm from "@/modules/Shared/Components/form/LabelForm.vue";
import CreatableSelect from "@/modules/Shared/Components/CreatableSelect.vue";

export default {
    name: "CommunityForm",
    components: {CreatableSelect, LabelForm},
    mixins: [],
    props: {
        value: {},
        conditions: {
            type: Array,
            default: () => []
        },
        reloadConditions: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            internalCommunity: {
                uuid: null,
                name: '',
                transactional_templates_prefix: '',
                transactionals_sender_email: '',
                id_conditions_ref: null,
                auto_validate_users: false,
                transactional_mail_provider: 'mailjet'
            },
            transactionalMailProviders: ['mailjet', 'brevo']
        }
    },
    watch: {
        value() {
            this.internalCommunity = JSON.parse(JSON.stringify(this.value))
        }
    },
    computed: {
        isValid() {
            return this.internalCommunity.name
                && this.internalCommunity.transactionals_sender_email
                && this.internalCommunity.id_conditions_ref
        }
    }
};
</script>
